<template>
  <div>
    <div class="container pt-5">
      <b-card v-if="showBanner" class="col-lg-6 col-md-12 m-auto border">
        <div>
          <div class="regular-24 text-center">Password Reset Instructions Have Been Emailed to You</div>
          <div class="regular-16 text-center">Please follow the link in your email to reset your password.</div>
        </div>
      </b-card>

      <b-card v-else class="col-lg-6 col-md-12 m-auto border">
        <b-form autocomplete="off" @submit="onSubmit">
          <h3 class="text-center mt-3 mb-5 lyon-display-medium-24">Password Recovery</h3>
          <b-form-group label="Email Address*">
            <b-input
              v-model="forgotPasswordForm.email"
              type="email"
              maxlength="50"
              :class="{'is-invalid': $v.forgotPasswordForm.email.$error, 'is-valid': !$v.forgotPasswordForm.email.$invalid}"
              placeholder="Email Address*"
              autocomplete="off"
              data-lpignore="true"
            />
            <b-form-invalid-feedback v-if="!$v.forgotPasswordForm.email.required || !$v.forgotPasswordForm.email.email">
              Please provide a valid email address.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group>
            <div ref="turnstile" class="turnstile-widget" />
          </b-form-group>

          <b-button type="submit" variant="primary" :disabled="!turnstileVerified || loading" block>
            <b-spinner v-if="loading" />SEND RESET EMAIL
          </b-button>
        </b-form>
        <div class="m-3 text-center"><small class="text-muted">or</small></div>
        <div class="mt-4 mb-3 text-center d-flex justify-content-center">
          <button type="button" class="nav-link" @click="openLoginModal">
            <span class="typo-color-blue">
              <i class="fas fa-user" />
              Login to Your SLMath Account
            </span>
          </button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators"

export default {
	name: "ForgotPassword",
	metaInfo: {
		title: "Forgot Password",
	},
	data() {
		return {
			forgotPasswordForm: {
				email: "",
			},
			showBanner: false,
			turnstileVerified: false,
			turnstileWidgetId: null,
			turnstileSiteKey: process.env.VUE_APP_TURNSTILE_SITE_KEY,
			token: "",
			loading: false,
		}
	},
	validations: {
		forgotPasswordForm: {
			email: {
				required,
				email,
			},
		},
	},
	mounted() {
		this.loadTurnstile()
	},
	beforeDestroy() {
		if (window.turnstile && this.turnstileWidgetId !== null) {
			window.turnstile.remove(this.turnstileWidgetId)
		}
	},
	methods: {
		openLoginModal() {
			this.$root.$emit("hideForgotPasswordModal")
			this.$root.$emit("openSigninModal")
		},
		loadTurnstile() {
			if (window.turnstile) {
				this.renderTurnstile()
				return
			}

			const existingScript = document.getElementById("turnstile-api")
			if (existingScript) {
				existingScript.addEventListener("load", this.renderTurnstile)
				return
			}

			const script = document.createElement("script")
			script.id = "turnstile-api"
			script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
			script.async = true
			script.defer = true
			script.addEventListener("load", this.renderTurnstile)
			document.head.appendChild(script)
		},
		renderTurnstile() {
			if (!window.turnstile || !this.$refs.turnstile || this.turnstileWidgetId !== null) {
				return
			}

			this.turnstileWidgetId = window.turnstile.render(this.$refs.turnstile, {
				sitekey: this.turnstileSiteKey,
				callback: (token) => {
					this.token = token
					this.turnstileVerified = true
				},
				"expired-callback": () => {
					this.token = ""
					this.turnstileVerified = false
				},
				"error-callback": () => {
					this.token = ""
					this.turnstileVerified = false
				},
			})
		},
		resetTurnstile() {
			this.token = ""
			this.turnstileVerified = false
			if (window.turnstile && this.turnstileWidgetId !== null) {
				window.turnstile.reset(this.turnstileWidgetId)
			}
		},
		onSubmit(event) {
			event.preventDefault()
			this.$v.$touch()
			if (!this.$v.$invalid && this.turnstileVerified) {
				this.loading = true
				this.$http
					.post(`${process.env.VUE_APP_API_URL}/forgot_password`, {
						email: this.forgotPasswordForm.email,
						"cf-turnstile-response": this.token,
					})
					.then((res) => {
						if (res !== undefined) {
							if (res.data.errors !== undefined) {
								this.$toasted.global.error(res.data.errors)
								this.resetTurnstile()
								// this.$router.replace({name: "signin"})
								this.$root.$emit("openSigninModal")
								this.$root.$emit("hideForgotPasswordModal")
							} else {
								this.$root.$emit("hideForgotPasswordModal")
								this.$toasted.global.success(
									"An email has been sent to you with instructions on how to reset your password.",
								)
								this.showBanner = true
							}
						} else {
							this.resetTurnstile()
						}
					})
					.catch(() => {
						this.resetTurnstile()
					})
					.finally(() => {
						this.loading = false
					})
			}
		},
	},
}
</script>

<style scoped lang='scss'>
  .nav-link {
    border: none;
    background: none;
    color: black;
    padding: 0 0;
  }

  .turnstile-widget {
    min-height: 65px;
  }
</style>
